const colors = {
    primary: '#303030',
    secondary: '#606060',
    warning: '#F8991D'
}

export default colors